import React from 'react'
import { compose } from 'recompose'
import Modal from 'components/modals/Modal'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton';
import withTemporaryForm from 'hocs/bases/withTemporaryForm'
import ElementFormController from './ElementFormController'

const ModalElementForm = compose(
  withTemporaryForm(),
)(
  ({
    value,
    onChange,
    onSubmit,
    onClose,
  }) => (
    <Modal
      open
      modal
      title={'Edit Element'}
      autoScrollBodyContent
      contentStyle={{
        width: '80%',
        maxWidth: 'none',
      }}
      actions={[
        <FlatButton
          label="Cancel"
          primary
          onTouchTap={onClose}
        />,
        <RaisedButton
          label="OK"
          secondary
          onTouchTap={() => {
            onSubmit()
            onClose()
          }}
        />,
      ]}
    >
      <ElementFormController
        element={value}
        updateElement={onChange}
      />
    </Modal>
  ),
)

ModalElementForm.propTypes = {}
ModalElementForm.defaultProps = {}

export default ModalElementForm



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/ModalElementForm.js